import { COLORS } from '@/constants';
import { Box } from '@mui/material';
import styled, { css } from 'styled-components';

export const PageBackground = styled.div<{ $bg?: string }>`
  background: ${({ $bg }) => $bg ?? 'transparent'};
`;

export const Container = styled.div`
  max-width: 1210px;
  margin: 0 auto;
  padding: 30px 0;
`;

export const MainBox = styled.div`
  display: flex;
  margin-top: 14px;
  justify-content: space-between;
  gap: 25px;
  padding: 0 30px;

  @media (max-width: 1280px) {
    flex-direction: column;
  }
`;

export const MainContentBox = styled.div`
  flex: 1;
  min-width: 0px;
  min-height: 420px;
  overflow: visible;

  @media (max-width: 1280px) {
    order: 2;
  }
`;

export const NavigationMenuContainer = styled.div`
  width: 100%;
  border: 1px solid ${COLORS['neutral/300']};
  background: ${COLORS['white']};
  border-radius: 6px;

  @media (max-width: 1280px) {
    order: 1;
  }
`;

export const NavigationMenuList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
`;

export const NavigationMenuItem = styled(Box)<{ $isActive?: boolean }>`
  display: flex;
  padding: 8px;
  align-items: center;
  border-radius: 4px;
  gap: 6px;
  cursor: pointer;
  background: ${({ $isActive }) => ($isActive ? COLORS['secondary/50'] : COLORS['white'])};
  color: ${({ $isActive }) => ($isActive ? COLORS['secondary/700'] : COLORS['neutral/950'])};

  svg {
    path {
      stroke: ${COLORS['primary/500']};
    }
  }

  &:hover {
    background: ${COLORS['secondary/50']};
    color: ${COLORS['secondary/700']};

    svg {
      path {
        stroke: ${COLORS['secondary/700']} !important;
      }
    }
  }

  svg {
    path {
      ${({ $isActive }) =>
        $isActive &&
        css`
          stroke: ${COLORS['secondary/700']} !important;
        `}
    }
  }
`;

export const NavigationMenuWrapper = styled.div`
  width: 270px;
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  top: 90px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 1280px) {
    width: 100%;
    position: relative;
    top: 0;
  }
`;

export const SidebarContactBoxWrapper = styled.div`
  display: block;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const NavigationSectionHeader = styled.div`
  padding: 12px 16px;
  font-size: 16px;
  font-height: 20px;
  font-weight: 700;
  color: ${COLORS['primary/950']};
  border-bottom: 1px solid ${COLORS['neutral/300']};
`;
